import { SET_FLEET } from './mutation-types'
import Vue from 'vue'

/**
 * Query all drivers
 *
 * @param {params} id the user id
 */
export function getFleet({ commit }) {
  return new Promise((resolve, reject) => {
    this._vm.$http
      .get('/api/company/users')
      .then(response => {
        commit(SET_FLEET, response.data)
      })
      .catch(err => {
        console.log(err)
      })
  })

  commit(SET_FLEET, fleet)
}

/**
 * create a new fleet driver
 *
 * @param {params} id the user id
 */
export function createDriver({ commit }, newuser) {
  
  return new Promise((resolve, reject) => {
    this._vm.$http
      .post('/api/dispatchuser', newuser)
      .then((response) => {
        this.dispatch('getFleet')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })  
}


/**
 * update a fleet driver
 *
 * @param {params} id the user id
 */
export function updateDriver({ commit }, user ) {

  return new Promise((resolve, reject) => {
    this._vm.$http
      .put('/api/dispatchuser', 
        user, 
        {
          headers: {
            Impersonate: user.id
          }  
        })
      .then((response) => {
        this.dispatch('getFleet')
        resolve(response)
      })
      .catch(err => {
        reject(err)
      })
  })  
}
